// extracted by mini-css-extract-plugin
export default {"fieldSpinner":"Ij3RL"};